import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import { fragment } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import SnapshotPdfType from '@linc-technologies/linced-common/enums/snapshot-pdf-type';
import type PdfInclude from '@linc-technologies/linced-common/models/snapshots/pdf-include';

// Proto: snapshots.Pdf.
export default class Pdf extends Fragment {
  declare [Type]: 'snapshots/pdf';

  @attr('string', { defaultValue: '' })
  declare mediaId: string;

  @attr('number', { defaultValue: SnapshotPdfType.BASIC })
  declare pdfType: EnumValue<typeof SnapshotPdfType>;

  @fragment('snapshots/pdf-include')
  declare pdfInclude: PdfInclude | null;

  @attr('number', { defaultValue: 0 })
  declare fileSize: number;
}
